module.exports = __webpack_public_path__ + "img/142.8d8f4a70.jpg";